// Version : 0.0.1
// Author : NANDHAKUMAR
// LastEdit : NANDHAKUMAR
// Last ADD : INACTIVE MEMBER REPORT
// MODIFIED DATE: 29-09-2025
import InActiveMemberActionTypes from './in-active-member.types';

/** ***************** GET INACTIVE MEMBER START *********************** */
export const getInActiveMemberDetailsStart = (getData: any) => ({
	type: InActiveMemberActionTypes.GET_INACTIVE_MEMBER_LIST_START,
	payload: getData,
});

export const getInActiveMemberDetailsSuccess = (successData: any) => ({
	type: InActiveMemberActionTypes.GET_INACTIVE_MEMBER_LIST_SUCCESS,
	payload: successData,
});

export const getInActiveMemberDetailsFailure = (failureData: any) => ({
	type: InActiveMemberActionTypes.GET_INACTIVE_MEMBER_LIST_FAILURE,
	payload: failureData,
});

export const getInActiveMemberDetailsResponseResetStart = () => ({
	type: InActiveMemberActionTypes.GET_INACTIVE_MEMBER_LIST_RESPONSE_RESET,
});

export const getInActiveMemberDetailsResponseChanged = () => ({
	type: InActiveMemberActionTypes.GET_INACTIVE_MEMBER_LIST_RESPONSE_CHANGED,
});
/** ***************** GET INACTIVE MEMBER END *********************** */
